// ERB::Util.html_escape's exact mapping, so text escaped here comes out byte-identical to the same
// text escaped on the server. Pure (no DOM), so `node --test` modules can import it.
const HTML_ESCAPES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
}

export function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>"']/g, (char) => HTML_ESCAPES[char])
}
